var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99998 3.41421L4.70709 7.70711C4.31656 8.09763 3.6834 8.09763 3.29288 7.70711C2.90235 7.31658 2.90235 6.68342 3.29288 6.29289L9.29287 0.292893C9.6834 -0.0976311 10.3166 -0.0976311 10.7071 0.292893L16.7071 6.29289C17.0976 6.68342 17.0976 7.31658 16.7071 7.70711C16.3166 8.09763 15.6834 8.09763 15.2929 7.70711L11 3.41421V15C11 15.5523 10.5523 16 9.99998 16C9.4477 16 8.99998 15.5523 8.99998 15V3.41421ZM18 15C18 14.4477 18.4477 14 19 14C19.5523 14 20 14.4477 20 15V18C20 19.1046 19.1046 20 18 20H2C0.895431 20 0 19.1046 0 18V15C0 14.4477 0.447715 14 1 14C1.55228 14 2 14.4477 2 15V18H18V15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.17f435889ee226c738000428c86b5a9d.svg";
export { ForwardRef as ReactComponent };